import React from 'react';
import { getCurrentModuleStatus } from '../SummaryCommon/SummaryCommon';
import { SummaryCardsActions } from '../SummaryCommon/ModuleCardsActions';

//Component for rendering diagnostics card actions

export const DiagnosticsCardActions = ({
  diagnostics_microcalc_module,
  diagnostics_opacities_module,
  annotatorRole,
  handleEditButtonClick,
  applied_microcalc,
  microcalcShown,
  isMicrocalcConfirmed,
  isMicrocalcRelabeled,
  onMicrocalcConfirmClick,
  applied_opacities,
  opacitiesShown,
  isOpacityConfirmed,
  isOpacityRelabeled,
  onOpacitiesConfirmClick,
  results,
  theme,
  t,
}) => {
  // Only render if at least one diagnostics module is enabled
  if (!diagnostics_microcalc_module && !diagnostics_opacities_module) {
    return null;
  }

  const modules = [];

  if (diagnostics_microcalc_module) {
    modules.push({
      name: 'calc',
      moduleStatus: getCurrentModuleStatus(
        applied_microcalc,
        microcalcShown,
        isMicrocalcConfirmed,
        isMicrocalcRelabeled,
        t('ResultView.diagnose_microcalc'),
        theme,
        t
      ),
      onConfirmClick: () =>
        onMicrocalcConfirmClick(microcalcShown, microcalcShown, applied_microcalc, isMicrocalcConfirmed),
      isReviewed: isMicrocalcConfirmed || isMicrocalcRelabeled,
    });
  }

  if (diagnostics_opacities_module) {
    modules.push({
      name: 'opac',
      moduleStatus: getCurrentModuleStatus(
        applied_opacities,
        opacitiesShown,
        isOpacityConfirmed,
        isOpacityRelabeled,
        t('ResultView.diagnose_opacities'),
        theme,
        t
      ),
      onConfirmClick: () =>
        onOpacitiesConfirmClick(opacitiesShown, opacitiesShown, applied_opacities, isOpacityConfirmed),
      isReviewed: isOpacityConfirmed || isOpacityRelabeled,
    });
  }

  return (
    <SummaryCardsActions
      annotatorRole={annotatorRole}
      handleEditButtonClick={handleEditButtonClick}
      multipleModules={modules}
      parentModuleName='diagnostics'
      hasResults={!!results}
    />
  );
};
